export const MENU = [
  {
    label: "Dashboard",
    link: "/dashboard",
    role: ["SUPER_ADMIN", "AGENT", "ATL", "TL", "CEO"],
  },

  {
    label: "Follow Ups",
    link: "/leads",
    role: ["SUPER_ADMIN", "AGENT", "ATL", "TL", "CEO"],
  },

  {
    label: "Master",
    link: "#",
    role: ["SUPER_ADMIN"],
    menu: [
      {
        label: "Employee",
        link: "#",
        menu: [
          {
            label: "Employees",
            link: "/agents",
          },
          {
            label: "Add Employee",
            link: "/agents/add",
          },
        ],
      },
      {
        label: "Lead Feedback Type",
        link: "#",
        menu: [
          {
            label: "View Lead Feedback Types",
            link: "/leadfeedbacktypes",
          },
          {
            label: "Add Lead Feedback Type",
            link: "/leadfeedbacktypes/add",
          },
        ],
      },

      {
        label: "Processing Type",
        link: "#",
        menu: [
          {
            label: "View Processing Types",
            link: "/processingtypes",
          },
          {
            label: "Add Processing Type",
            link: "/processingtypes/add",
          },
        ],
      },
      {
        label: "Status",
        link: "#",
        menu: [
          {
            label: "View Status",
            link: "/status",
          },
          {
            label: "Add Status",
            link: "/status/add",
          },
        ],
      },
      {
        label: "Product",
        link: "#",
        menu: [
          {
            label: "View Products",
            link: "/products",
          },
          {
            label: "Add Product",
            link: "/products/add",
          },
        ],
      },
      {
        label: "Teams",
        link: "#",
        menu: [
          {
            label: "View Teams",
            link: "/teams",
          },
          {
            label: "Add Team",
            link: "/teams/add",
          },
        ],
      },
      {
        label: "Centre",
        link: "#",
        menu: [
          {
            label: "View Centres",
            link: "/centres",
          },
          {
            label: "Add Centre",
            link: "/centres/add",
          },
        ],
      },
      {
        label: "Clients",
        link: "#",
        menu: [
          {
            label: "View Clients",
            link: "/clients",
          },
          {
            label: "Add Client",
            link: "/clients/add",
          },
        ],
      },
    ],
  },
];
